import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Recipes/Create';

const { displayName } = config;

function RecipeCreate(): React.JSX.Element {
  document.title = `${displayName}: Добавить рецепт`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default RecipeCreate;
